export const LIST_BRANCH_PHARMACY_PRICE_REQUEST =
  'LIST_BRANCH_PHARMACY_PRICE_REQUEST'
export const LIST_BRANCH_PHARMACY_PRICE_SUCCESS =
  'LIST_BRANCH_PHARMACY_PRICE_SUCCESS'
export const LIST_BRANCH_PHARMACY_PRICE_FAIL =
  'LIST_BRANCH_PHARMACY_PRICE_FAIL'

export const PATCH_BRANCH_PHARMACY_PRICE_REQUEST =
  'PATCH_BRANCH_PHARMACY_PRICE_REQUEST'
export const PATCH_BRANCH_PHARMACY_PRICE_SUCCESS =
  'PATCH_BRANCH_PHARMACY_PRICE_SUCCESS'
export const PATCH_BRANCH_PHARMACY_PRICE_FAIL =
  'PATCH_BRANCH_PHARMACY_PRICE_FAIL'

export const DETAIL_BRANCH_PHARMACY_PRICE_REQUEST =
  'DETAIL_BRANCH_PHARMACY_PRICE_REQUEST'
export const DETAIL_BRANCH_PHARMACY_PRICE_SUCCESS =
  'DETAIL_BRANCH_PHARMACY_PRICE_SUCCESS'  
export const DETAIL_BRANCH_PHARMACY_PRICE_FAIL =
  'DETAIL_BRANCH_PHARMACY_PRICE_FAIL'
